import type { App } from 'vue'
import AuthService from './AuthService'
import ProducerService from './ProducerService'
import AdminService from './AdminService'
import ServiceProvider from './ServiceProvider'
import CouponService from './CouponService'
import ViaCEPService from './ViaCEPService'
import BiometricProviderService from './BiometricProviderService'

type Constructor<T> = new (...args: unknown[]) => T

export function register(app: App) {
  const provider = new ServiceProvider()

  const services = [
    { name: AuthService, build: () => new AuthService() },
    { name: ProducerService, build: () => new ProducerService() },
    { name: AdminService, build: () => new AdminService() },
    { name: CouponService, build: () => new CouponService() },
    { name: ViaCEPService, build: () => new ViaCEPService() },
    { name: BiometricProviderService, build: () => new BiometricProviderService() },
  ] as {
    name: Constructor<unknown>
    build: () => unknown
  }[]

  for (const service of services) {
    provider.register(service.name, service.build)
  }

  app.config.globalProperties.$services = provider
}
